/**
 * Constants for EditVendorPageV2 component
 */

export const STEPS = [
	{
		title: 'Basic Information',
		key: 'basic_information',
	},
	{
		title: 'Business Information',
		key: 'business_information',
	},
	{
		title: 'Banking Information',
		key: 'banking_information',
	},
	{
		title: 'Vehicle Information',
		key: 'vehicle_information',
	},
	{
		title: 'Serviceability Info',
		key: 'serviceability_info',
	},
];

export const EMPTY_STRING = '';
export const VENDOR_LIST_ROUTE = '/vendor-list';
